import React, { Component } from 'react';
import { connect } from 'react-redux';
import T from 'i18n-react';
import Loader from 'react-loader';
// Style
import './ReportingPeriodic.css';
// Components
import ReportingHeaderPeriodic from '../../components/tableComponent/periodic/ReportingHeaderPeriodic';
import TableStrippedPeriodic from '../../components/tableComponent/periodic/TableStrippedPeriodic';
import ExportCsv from '../../components/tableComponent/export/ExportCsv';
import ExportPdf from '../../components/tableComponent/export/pdf/ExportPdf';
// Service
import OperationService from '../../services/OperationService';
import ShopService from '../../services/ShopService';
// Utils
import { makeCancelable } from '../../utils/PromiseUtils';
import NotificationSystem from 'react-notification-system';
import { notificationStyle } from '../../utils/NotificationUtils';
import { getStreamTypeListFromLocation } from '../../enums/StreamType';
import UserService from "../../services/UserService";
// Enums
import LOCATION from '../../enums/Location';
import ColorEnum from "../../enums/ColorEnum";
import InvoiceService from "../../services/InvoiceService";
import INVOICE_CHECK_STATUS from "../../enums/InvoiceCheckStatus";
// Store
import {
    setEndDateAction,
    setFilterActivityAction,
    setFilterBUAction,
    setFilterClientAction,
    setFilterLocationAction,
    setFilterPaymentTypeAction,
    setFilterShopAction,
    setReportingFilterIsOpenAction,
    setStartDateAction
} from '../../store/filters/FilterActions';
import { Checkbox } from "material-ui";

/*************************************************
 * ************* Mapping du store ****************
 *************************************************/

const mapStateToProps = (state) => ({
    userData: state.userState.userData,
    filters: state.filterState
});

const mapDispatchToProps = (dispatch) => ({
    /**
     * Met dans le store les informations récupéré du Country
     * @param country
     */
    setFilterLocation: (country) => dispatch(setFilterLocationAction(country)),
    /**
     * Met dans le store les informations récupéré du client
     * @param client
     */
     setFilterClient: (client) => dispatch(setFilterClientAction(client)),
    /**
     * Met dans le store les informations récupéré du bu
     * @param bu
     */
     setFilterBU: (bu) => dispatch(setFilterBUAction(bu)),
    /**
     * Met dans le store les informations récupéré du shop
     * @param shop
     */
     setFilterShop: (shop) => dispatch(setFilterShopAction(shop)),
     /**
     * Met dans le store les informations récupéré du startDate
     * @param startDate
     */
     setStartDateAction: (startDate) => dispatch(setStartDateAction(startDate)),
    /**
     * Met dans le store les informations récupéré du endDate
     * @param endDate
     */
     setEndDateAction: (endDate) => dispatch(setEndDateAction(endDate)),
    /**
     * Met dans le store les informations récupérées du moyen de paiement
     * @param paymentType
     */
    setFilterPaymentType: (paymentType) => dispatch(setFilterPaymentTypeAction(paymentType)),
    /**
     * Met dans le store les informations récupérées de l'activité
     * @param activity
     */
    setFilterActivity: (activity) => dispatch(setFilterActivityAction(activity)),
    /**
     * Met dans le store les informations pour ouvrir ou fermer les filtres
     * @param isOpen
     */
    setReportingFilterIsOpen: (isOpen) => dispatch(setReportingFilterIsOpenAction(isOpen))
});

class ReportingPeriodicPage extends Component {

    /**********************************************************
     * ******************** LifeCycle *************************
     **********************************************************/
    constructor(props) {
        super(props);
        this.state = {
            selectedStreamType: null,
            dataOperation: {},
            userData: props.userData,
            location: null,
            hideTable: true,
            hideTableMessagei18nCode: 'table.hideDefaultMessage',
            beginDate: '',
            endDate: '',
            dataOperationCsv: {},
            loaded: true,
            cardTypes: [],
            activities: [],
            detailsDateTransaction: false,
        };
        this._promises = [];
        this.setAllCardTypes();
        this.setAllActivities();
    }

    componentWillMount() {
        this.setState((state, props) => {
            const shopList = props.userData.shopList;
            const buList = props.userData.businessUnitList;
            const clientList = props.userData.clientList;
            const initFilters = props.filters;
            let userEntities = UserService.initUserEntities(clientList, buList, shopList, initFilters);
            //Belgique par défaut
            const location = userEntities.location
            return {
                allShopList: shopList,
                shopList,
                buList,
                clientList,
                idShop: userEntities.shop ? userEntities.shop.id : null,
                selectedBu: userEntities.bu,
                location,
                streamTypeList: getStreamTypeListFromLocation(location),
                beginDate: initFilters.startDate,
                endDate: initFilters.endDate,
                selectedCardTypes: userEntities.paymentType,
                selectedActivities: userEntities.activity
            }
        }, this.fetchOperation);
    }

    /**
     * On set le system de notification après que la page soit chargé
     */
    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem;
        this.getShopListFilteredFromWS();
    }

    /**
     * Annulation de toutes les promesses encore en cours lorsque
     * l'on quitte le composant
     */
    componentWillUnMount() {
        this._promises.forEach(promise => promise.cancel());
    }

    render() {
        return(
            <div className="homePage">
                <div className="headerSearchOperation">
                    <ReportingHeaderPeriodic userProfile={this.props.userProfile}
                                     dateAction={this.changeDate.bind(this)}
                                     clientList={this.state.clientList}
                                     beginDate={this.state.beginDate}
                                     endDate={this.state.endDate}
                                     buList={this.state.buList}
                                     cleanData={this.cleanHeaderParam.bind(this)}
                                     shopList={this.state.shopList}
                                     allShopList={this.state.allShopList}
                                     location={this.state.location}
                                     shopAction={this.changeShop.bind(this)}
                                     buAction={this.changeBu.bind(this)}
                                     clientAction={this.changeClient.bind(this)}
                                     streamTypeAction={this.changeStreamType}
                                     streamTypeList={this.state.streamTypeList}
                                     initFilters ={this.props.filters}
                                     setStartDateAction={this.props.setStartDateAction}
                                     setEndDateAction={this.props.setEndDateAction}
                                     cardTypes={this.state.cardTypes}
                                     cardTypeAction={this.changeCardType}
                                     activities={this.state.activities}
                                     activityAction={this.changeActivity}
                                     openAction={this.props.setReportingFilterIsOpen}
                    />
                </div>
                <Loader loaded={this.state.loaded} color={ColorEnum.GREEN}>
                    <div className="homePageContent">
                        <div className="title">
                            <div>
                                {T.translate("table.operationDetails")}
                            </div>
                            {
                                !this.state.hideTable && this.state.dataOperation && this.state.dataOperation.operationPeriodicList && this.state.dataOperation.operationPeriodicList.length > 0 && this.state.location === LOCATION.BE?
                                    <div className="financialAccount"> <span className="labelIban">{this.state.iban ? T.translate("table.ibanInformation") + " : " : T.translate("table.multipleIban")}</span> {this.state.iban}</div>
                                    : ''
                            }
                        </div>
                        { this.state.selectedBu || this.state.userData.businessUnit ||
                        ( this.state.userData.shopList && this.state.userData.shopList.length > 0) ?
                            this.state.hideTable ?
                                <div className="helpMessageHome"> {T.translate(!!this.state.hideTableMessagei18nCode ? this.state.hideTableMessagei18nCode : 'table.hideDefaultMessage')} </div>
                                :
                                !this.state.dataOperation || this.state.dataOperation.operationPeriodicList.length === 0 ?
                                    <div className="helpMessageHome">{T.translate("table.empty")}</div>
                                    :
                                    <div className="tableOperation">
                                        <TableStrippedPeriodic
                                            operationList={this.state.dataOperation}
                                            location={this.state.location}
                                            selectedStreamType={this.state.selectedStreamType}
                                            detailsDateTransaction={this.state.detailsDateTransaction}
                                            handleInvoiceDownload={this.handleInvoiceDownload.bind(this)}
                                        />
                                    </div>
                            :
                            <div className="helpMessageHome"> {T.translate('table.chooseBu')} </div>
                        }
                        {this.state.dataOperation && this.state.dataOperation.operationPeriodicList && this.state.dataOperation.operationPeriodicList.length > 0 && !this.state.hideTable ?
                            <div className="reportingFooter">
                                <Checkbox
                                    className="checkbox"
                                    label={T.translate('reportingPeriodicPage.detailsDateTransaction')}
                                    checked={this.state.detailsDateTransaction}
                                    onCheck={this.handledetailsDateTransactionChange}/>
                                <ExportPdf startLocalDate={this.state.beginDate}
                                           endLocalDate={this.state.endDate}
                                           idShop={this.state.idShop}
                                           idBu={this.state.selectedBu ? this.state.selectedBu.id : null}
                                           selectedStreamType={null}
                                           selectedCardTypes={this.state.selectedCardTypes}
                                           selectedActivities={this.state.selectedActivities}
                                           detailsDateTransaction={this.state.detailsDateTransaction}/>
                                {/*selectedStreamType={this.state.selectedStreamType}/>*/}
                                {/*!!! TODO LEO CACHE_PASS !!! code modifié pour ne pas afficher la gestion des flux en attendant le go MarketPay , on force le flux CB en france*/}
                                <ExportCsv
                                    operationList={this.state.dataOperationCsv}
                                    fundingDate={'from_' + this.state.beginDate + '_to_' + this.state.endDate}
                                    selectedCountry={this.state.location}
                                    bu={this.state.selectedBu}
                                    client={this.getClientFromBu(this.state.selectedBu)}
                                />
                            </div> : ''
                        }
                    </div>
                </Loader>
                <NotificationSystem ref="notificationSystem" style={notificationStyle}/>
            </div>
        );
    }

    /**********************************************************
     * ******************* Web Services ***********************
     **********************************************************/

    /**
     * Méthode générique pour les appels WS
     * @param {*} promise
     * @param {*function} callback
     */
    callWebService(promise, callback) {
        const cancelablePromise = makeCancelable(promise);
        this._promises.push(cancelablePromise);
        cancelablePromise
            .promise
            .then((data) => {
                callback(data);
            })
            .catch((error) => {
                if (!error.isCanceled) {
                    this._addNotification(T.translate('common.errorOccurredSearch'), 'error');
                }
            })
            .then(() => this.promiseFulfilled(promise));
    }


    /**
     * Appel WS pour la récupération des informations des transactions
     * @param {*} date
     */
    fetchOperation() {
        let idBu;
        if(this.state.selectedBu) {
            idBu = this.state.selectedBu.id
        }
        if(!this.isValidStreamType()) {
            this.setState({
                hideTable: true,
                hideTableMessagei18nCode: 'table.invalidStreamType'
            });
            return;
        }
        if(this.state.beginDate && this.state.endDate) {
            this.setLoaded(false);
            // !!! TODO LEO CACHE_PASS !!! code commenté pour ne pas afficher la gestion des flux en attendant le go MarketPay , on force le flux CB en France
            // const getOperationListPromise = OperationService.getOperationListFromPeriod(this.state.beginDate, this.state.endDate, this.state.idShop, idBu, this.state.selectedStreamType);
            const temporaryStreamTypeForced = null;
            const getOperationListPromise = OperationService.getOperationListFromPeriod(this.state.beginDate, this.state.endDate, this.state.idShop, idBu, temporaryStreamTypeForced, this.state.selectedCardTypes, this.state.selectedActivities, this.state.detailsDateTransaction);
            this.callWebService(getOperationListPromise, (data) => {
                this.sortDataByDefault(data);
                let iban = data.iban;
                let dataOperationCsv = [];
                data.operationPeriodicList.forEach((operationList) => {
                    operationList.operationList.forEach((operation) => {
                        dataOperationCsv.push(operation);
                    });
                });
                this.setState({
                    dataOperation: data,
                    dataOperationCsv: dataOperationCsv,
                    iban: iban,
                    hideTable: false,
                    hideTableMessagei18nCode: 'table.hideDefaultMessage'
                });
                this.setLoaded(true);
            });
        }
    }

    setAllCardTypes() {
        const getCardTypesPromise = OperationService.getAllCardTypes();
        this.callWebService(getCardTypesPromise, (data) => {
            this.setState({
                cardTypes: data
            });
            this.setLoaded(true);
        });
    }

    setAllActivities() {
        const getActivitiesPromise = OperationService.getAllCardActivities();
        this.callWebService(getActivitiesPromise, (data) => {
            this.setState({
                activities: data
            });
            this.setLoaded(true);
        });
    }

    /**
     * Récupére la liste de tout les magasins ( utilisé uniquement pour les admins )
     */
    getAllShopList() {
        const getShopUserListPromise = ShopService.getShopList();
        this.callWebService(getShopUserListPromise, (data) => {
            this.setState({
                shopList: data.shopList,
                allShopList: data.shopList
            })
        })
    }

    /**
     * Récupération de la liste des shop filtrée par bu
     */
    getShopListFilteredFromWS() {
        let buId;
        if (this.state.userData.shopList && this.state.userData.shopList.length === 1) {
            return
        }
        if(this.state.userData.businessUnit) {
            buId = this.state.userData.businessUnit.id
        } else if(this.state.selectedBu) {
            buId = this.state.selectedBu.id
        }

        const getShopUserListPromise = ShopService.getShopList(buId);
        this.callWebService(getShopUserListPromise, (data) => {
            this.setState({
                shopList: data.shopList
            });
        })
    }

    /**
     * Récupère le client correspondant à une BU dans la liste de clients de l'utilisateur
     * @param bu
     */
    getClientFromBu(bu){
        if(bu){
            return this.state.userData.clientList.find(client => client.id === bu.idClient);
        } else {
            return null;
        }
    }

    /**********************************************************
     * **************** Actions composants ********************
     **********************************************************/

    /**
     * Action effectué a chaque changement de date
     * Mise à jour de la date dans le state
     */
    changeDate(objectDate) {
        this.setState(objectDate, this.fetchOperation);
    }

    /**
     * Permet de remettre les paramètres du Header à 0 (utilisé notamment pour l'adminMP au changement de pays)
     */
    cleanHeaderParam(country) {
        this.props.setFilterLocation(country)
        this.props.setFilterClient(null)
        this.props.setFilterBU(null)
        this.props.setFilterShop(null)
        this.props.setStartDateAction(null)
        this.props.setEndDateAction(null)
        this.props.setFilterPaymentType(null)
        this.props.setFilterActivity(null)
        this.setState({
            selectedBu : null,
            idShop: null,
            beginDate: null,
            endDate: null,
            shopList: null,
            dataOperation: null,
            allShopList: null,
            dataOperationCsv: null,
            selectedStreamType: null,
            streamTypeList: getStreamTypeListFromLocation(country),
            selectedCardTypes: null,
            selectedActivities: null
        }, this.getShopListFilteredFromWS)
    }

    changeShop(shop, selectedBu, selectedClient) {
        const idShop = shop ? shop.id : null;
        if (selectedBu) {
            this.props.setFilterShop(shop)
            this.props.setFilterClient(selectedClient)
            this.props.setFilterBU(selectedBu)
            this.props.setFilterLocation(selectedBu.location)
            this.props.setStartDateAction(null)
            this.props.setEndDateAction(null)
            this.setState({
                idShop: idShop,
                dataOperation: null,
                dataOperationCsv: null,
                selectedBu: selectedBu,
                location: selectedBu.location
            }, () => {
                this.getShopListFilteredFromWS();
                if (this.state.beginDate && this.state.endDate) {
                 this.fetchOperation();
                }
            })
        } else {
            this.props.setFilterShop(shop)
            this.props.setStartDateAction(null)
            this.props.setEndDateAction(null)
            this.setState({
                idShop: idShop,
                dataOperation: null,
                dataOperationCsv: null,
            }, () => {
                if (this.state.beginDate && this.state.endDate) {
                    this.fetchOperation();
                }
            });
        }
    }

    changeBu(bu, selectedClient) {
        const location = bu ? bu.location : null
        this.props.setFilterClient(selectedClient)
        this.props.setFilterBU(bu)
        this.props.setFilterShop(null)
        this.props.setFilterLocation(location)
        this.props.setStartDateAction(null)
        this.props.setEndDateAction(null)
        this.setState({
            selectedBu: bu,
            idShop: null,
            location: location,
            streamTypeList: getStreamTypeListFromLocation(location),
            dataOperation: null,
            dataOperationCsv: null
        }, this.getShopListFilteredFromWS);
    }

    changeClient(client){
        const location = client ? client.location : null
        this.props.setFilterClient(client)
        this.props.setFilterBU(null)
        this.props.setFilterShop(null)
        this.props.setStartDateAction(null)
        this.props.setEndDateAction(null)
        this.setState({
            selectedBu: null,
            idShop: null,
            location: location,
            streamTypeList: getStreamTypeListFromLocation(location),
            dataOperation: null,
            dataOperationCsv: null
        })
    }

    changeStreamType = (streamType) => {
        this.setState({selectedStreamType: streamType}, this.fetchOperation)
    };

    /**
     * Méthode qui vérifie si un type de flux a bien été choisi si il y a une liste
     */
    isValidStreamType = () => {
        return !(!!this.state.streamTypeList && this.state.streamTypeList.length > 0) || !!this.state.selectedStreamType
    };

    changeCardType = (cardType) => {
        this.props.setFilterPaymentType(cardType)
        this.setState({selectedCardTypes: cardType}, this.fetchOperation)
    }

    changeActivity = (activity) => {
        this.props.setFilterActivity(activity)
        this.setState({selectedActivities: activity}, this.fetchOperation)
    }

    handledetailsDateTransactionChange = (event) => {
        this.setState({detailsDateTransaction: event.target.checked}, this.fetchOperation)
    };

    /**********************************************************
     * ************** Formattage des données ******************
     **********************************************************/

    /**
     * Trie le tableau des transactions
     */
    sortDataByDefault(data) {
        data.operationPeriodicList.forEach(operationPeriodicResource => {
            operationPeriodicResource.operationList.sort(OperationService.getDefaultSortOperationDefaultFunction())
        })
    }

    /**********************************************************
     * ************** Gestion des promises ******************
     **********************************************************/

    /**
     * On retire la promise de la liste des promises en cours
     * Cette fonction doit etre appelé après que la promise est rempli
     * @param promise
     */
    promiseFulfilled(promise){
        const index = this._promises.indexOf(promise);

        if (index !== -1) {
            this._promises.splice(index, 1);
        }
    };

    /**********************************************************
     ****************** Gestion de facture ********************
     **********************************************************/

    /**
     *On vérifie qu'une facture pdf est bien associée à l'opération
     * @param invoiceId identifiant de la facture
     */
    handleInvoiceDownload(invoiceId) {
        InvoiceService.checkInvoice(invoiceId)
            .then(res => {
                const checkStatus = Object.keys(INVOICE_CHECK_STATUS).find(status => INVOICE_CHECK_STATUS[status].code === res.status);
                if(INVOICE_CHECK_STATUS.SUCCESS.code === res.status) {
                    InvoiceService.downloadInvoice(invoiceId);
                } else {
                    const errorMessage = checkStatus ? T.translate('invoicePage.pdfViewer.status.' + checkStatus) : T.translate('common.errorOccurred');
                    const level = checkStatus ? INVOICE_CHECK_STATUS[checkStatus].level : 'error'
                    this._addNotification(errorMessage, level);
                }
            });
    }

    /**********************************************************
     ********************* Loader *****************************
     **********************************************************/

    /**
     * On active/désactive le loader
     * @param loaded
     */
    setLoaded(loaded) {
        this.setState({
            loaded: loaded
        });
    }

    /*************************************************
     ****************Notifications ******************
     *************************************************/

    _notificationSystem = null;

    _addNotification = (message, level) => {
        this._notificationSystem.addNotification({
            message,
            autoDismiss: 5,
            level,
            position: 'tr'
        });
    };

}

export default connect(mapStateToProps, mapDispatchToProps)(ReportingPeriodicPage);


// WEBPACK FOOTER //
// ./src/ui/reportingPeriodic/ReportingPeriodic.js